import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasCentrifugas/BombasCentrifugas1.png';
import Img2 from '../../img/products/bombas/BombasCentrifugas/BombasCentrifugas2.png';
import Img3 from '../../img/products/bombas/BombasCentrifugas/BombasCentrifugas3.png';
import Img4 from '../../img/products/bombas/BombasCentrifugas/BombasCentrifugas4.png';

const BombasCentrifugas = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas Centrífugas</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas centrífugas son dispositivos utilizados para mover fluidos mediante la transferencia
            de energía desde un motor a través de un impulsor giratorio. Estas bombas son ampliamente
            utilizadas en los diferentes sectores del mercado debido a su diseño eficiente y su capacidad
            para manejar grandes volúmenes de fluidos a diferentes presiones.
          </p>
          <p className="lead text-justify">
            El impulsor es la parte fundamental de la bomba, encargado de convertir la energía mecánica en
            energía hidráulica, lo que permite mover el fluido. Están disponibles en una amplia variedad de
            configuraciones, incluyendo bombas de succión final, bombas en línea, bombas de carcasa partida
            y bombas de turbina vertical.
          </p>
          <p className="lead text-justify">
            Las bombas centrífugas son altamente eficientes en la transferencia de energía y pueden mover
            grandes volúmenes de fluido con un consumo de energía relativamente bajo. Son conocidas por su
            fiabilidad y durabilidad, lo que las hace adecuadas para aplicaciones críticas donde el tiempo
            de inactividad debe minimizarse.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BombasCentrifugas;
